export const clanTranslations = {
  ru: {
    back: "Сообщества",
    recruitmentOpen: "Набор открыт",
    recruitmentClosed: "Набор закрыт",
    founded: "Основано",
    invite: "Пригласить",
    applications: "Заявки",
    settings: "Настройки",
    audit: "Журнал",
    applyBtn: "Подать заявку",
    contacts: "Связь",
    discord: "Discord сервер",
    notSpecified: "Не указан",
    membersTitle: "Участники",
    search: "Поиск...",
    feedTitle: "Лента сообщества",
    writePost: "Что нового в вашем сообществе?",
    publish: "Опубликовать",
    uploading: "Загрузка...",
    emptyFeed: "В этом сообществе пока нет постов.",
    permissions: {
      postLabel: "Кто может публиковать посты",
      all: "Все участники",
      leaders: "Только лидеры и офицеры"
    }
  },
  en: {
    back: "Communities",
    recruitmentOpen: "Recruitment Open",
    recruitmentClosed: "Recruitment Closed",
    founded: "Founded",
    invite: "Invite",
    applications: "Applications",
    settings: "Settings",
    audit: "Audit Log",
    applyBtn: "Apply to Join",
    contacts: "Contacts",
    discord: "Discord Server",
    notSpecified: "Not specified",
    membersTitle: "Members",
    search: "Search...",
    feedTitle: "Community Feed",
    writePost: "What's new in your community?",
    publish: "Publish",
    uploading: "Uploading...",
    emptyFeed: "No posts in this community yet.",
    permissions: {
      postLabel: "Who can publish posts",
      all: "All members",
      leaders: "Only leaders and officers"
    }
  }
};